<template>

	<div class="w-full">

        <div class="w-full text-center" v-if="loading">
            <div class="py-5" colspan="4">
                <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
            </div>
        </div>

        <!-- chasers -->
        <div class="flex flex-wrap">
            <div class="w-full bg-white rounded-lg shadow p-6 mb-6" v-for="announcement in announcements">
				<h3 class="text-lg md:text-xl font-semibold pb-3 border-b-2 border-grey-lighter mb-4 relative">
                    {{ announcement.title }} <small> by {{announcement.sender.name}}</small>

					<div class="w-full text-sm md:text-xl md:w-auto md:absolute md:top-0 md:right-0">
						{{ announcement.created_at | displayLocalDateTime }}
					</div>
                </h3>
                <div class="w-full">
                    <p>{{announcement.message}}</p>
					<div class="w-full text-right pt-5">
						<router-link :to="{ name: 'StringerAnnouncementView', params: { uuid: announcement.id }}" class="bg-blue-700 text-white rounded px-4 py-2">
							View discussion
						</router-link>
					</div>
                </div>
            </div>
        </div>

        <!-- chasers -->
        <div class="flex flex-wrap">
            <div class="w-full bg-white rounded-lg shadow p-6 mb-6 py-10 text-center" v-if="announcements.length == 0 && loading == false">
                <h2>No announcements found! Once one is posted, it will appear here.</h2>
            </div>
        </div>

    </div>

</template>

<script>

	import * as Config from '@/config'
	import { mapState, mapGetters } from 'vuex';
	import { EventBus } from '@/utils/events';

	import moment from 'moment';

	export default {
		name: 'Announcements',
		data () {
			return {
				announcements: [],
                loading: true,
			}
		},
		mounted() {
			this.getAnnouncements();
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
			]),
			getAnnouncements() {
                this.$http.get(Config.apiPath + "/api/v2/stringer/announcements", this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'announcements', response.data)
                    this.$set(this, 'loading', false)
                });
            },
		},
		filters: {
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            }
        }
		
	}
</script>

<style scoped>

	.user-panel {
		background-color: #F6F7F8;
	}

</style>
